define('home/collections/NotificationCollection',[
    'underscore',
    'backbone',

    'core/api',
    'core/config',

    'home/collections/FeedItemCollection',
], function (
    _,
    Backbone,

    api,
    coreConfig,

    FeedItemCollection
) {
    'use strict';

    var parent = FeedItemCollection;
    var parentProto = parent.prototype;

    var NotificationCollection = parent.extend({
        fetch: function (options) {
            options = options ? _.clone(options) : {};
            options.data = options.data ? _.clone(options.data) : {};

            // no need to check if readPosition is undefined because
            // $.ajax will ignore undefined values in options.data
            options.data.readPosition = this.readPosition;
            options.data.routingVersion = coreConfig.feedApiVersion;

            return parentProto.fetch.call(this, options);
        },

        parse: function (response, options) {
            // readPosition is saved to pass on subsequent fetches for more notifications.
            // This will ensure that the api will correctly mark the returned notifications
            // as read or not, based on the original readPosition and not based on a
            // readPosition that we update ourselves during this session.
            if (!this.readPosition || options.reset)
                this.readPosition = response.response.readPosition;

            var parsed = parentProto.parse.apply(this, arguments);
            var NotificationCardCollectionView = require('home/views/NotificationCardCollectionView');

            return _.filter(parsed, function (item) {
                if (_.chain(NotificationCardCollectionView.ITEM_VIEWS).keys().contains(item.get('verb')).value())
                    return true;

                if (window.Raven)
                    window.Raven.captureMessage('unsupported activity item', { extra: item });
            });
        },

        syncReadPosition: function () {
            var latestPosition = this.latestPosition;

            if (!latestPosition ||
                // avoid calling setReadPosition repeatedly with same value
                latestPosition === this.previousLatestPosition ||
                latestPosition === this.readPosition)
                return;

            this.previousLatestPosition = latestPosition;

            // TODO use this.sync here?
            Backbone.ajax({
                url: api.getURL('timelines/setReadPosition'),
                type: 'POST',
                data: _.extend({}, this.uniqueTogether, {
                    position: latestPosition,
                }),
            });
        },
    });

    return NotificationCollection;
});

